import { CcRequirementType } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setCcRequirementTypeList = (typeList: types.CcRequirementTypeList) => ({
    type: inferLiteral(types.CC_REQUIREMENT_TYPE_LIST),
    typeList,
})
export const setCcRequirementTypeIds = (typeIds: readonly number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_TYPE_IDS),
    typeIds,
})
export const setCcRequirementTypeEdit = (value: CcRequirementType) => ({
    type: inferLiteral(types.CC_REQUIREMENT_TYPE_EDIT),
    value,
})
export const setCcRequirementTypeSort = (sortColumn: keyof CcRequirementType, sortOrder: OrderType) => ({
    type: inferLiteral(types.CC_REQUIREMENT_TYPE_SORT),
    sortColumn,
    sortOrder,
})
export const setCcRequirementTypeFilters = (filters: types.CcRequirementTypeFilters) => ({
    type: inferLiteral(types.CC_REQUIREMENT_TYPE_FILTERS),
    filters,
})
export const setCcRequirementTypeReloadList = (value: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_TYPE_RELOAD_LIST),
    value,
})
export const setCcRequirementTypeReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_TYPE_RELOAD_EDIT),
    value,
})
